import { Component, OnDestroy } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PasswordData } from '../model/password.model';

/**
 *  let config: DynamicDialogConfig = {
      width: '85%',
      style: { overflow: 'scroll', 'max-height': '60%' },
      showHeader: false,
      data: {
        function: this.doLogin.bind(this);
      }
    };
    let passwordRef = this.dialogService.open(PasswordComponent, config)
    passwordRef.onClose.pipe(take(1)).subscribe((resultDoLoginFn: any) => {
      ...
    });
 */
@Component({
  selector: 'password-window',
  templateUrl: 'password.template.html'
})
export class PasswordComponent extends BaseComponent implements OnDestroy {

  public data: PasswordData;
  public errorMsg: string;
  public showWait: boolean;

  constructor(private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig,
    private plycaErrorHandler: PlycaErrorHandler) {
    super();
    if (!this.dialogConfig?.data?.function) {
      console.error('Error al invocar al componente, debe especificarse funcion de login en dialogConfig.data.function ');
      this.dialogRef.close();
    }
    this.data = new PasswordData();
  }
  public close(): void {
    this.dialogRef.close();
  }

  public accept(): void {
    let result = this.dialogConfig.data.function.call(this, this.data);
    this.showWait = true;
    if (result instanceof Observable) {
      this.subscribe(result.pipe(
        catchError((error: any) => {
          this.showWait = false;
          this.errorMsg = this.plycaErrorHandler.getErrorMessage(error);
          return throwError(error);
        }),
        tap((fnResult: any) => {
          this.showWait = false;
          this.dialogRef.close(fnResult)
        })
      ));
    } else {
      this.showWait = false;
      try {
        this.dialogRef.close(result);
      } catch (error) {
        this.errorMsg = this.plycaErrorHandler.getErrorMessage(error);
      }
    }
  }

  ngOnDestroy() {
    this.dialogConfig = null;
    this.dialogRef = null;
    super.ngOnDestroy();
  }

}
